module.exports = __webpack_public_path__ + "static/media/loja-juveve.9b0170ba.jpg";